import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type CustomerAccountsAdBlocksEditFlatTeamSettingGroupId =
  "customer_accounts_ad_blocks_edit.ad_blocks_edit";

const groupOwner: SettingOwner = {
  kind: "teamSettings",
  product: "fulfillment",
};

const groupRisk: SettingRisk = {
  level: "low",
  reason:
    "Storefront customer-account settings including native accounts, ad blocks, and integrations.",
};

export const CustomerAccountsAdBlocksEditFlatTeamSettingGroups = [
  {
    id: "customer_accounts_ad_blocks_edit.ad_blocks_edit",
    title: "Ad blocks edit",
    description:
      "Ad blocks edit settings on the Customer accounts ad blocks edit page.",
    productArea: "general",
    access: directMerchantAccess(
      SettingsPermissions.SET_CUSTOMER_ACCOUNTS_SETTINGS,
    ),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: {
      type: "settings",
      // The edit page needs an :adBlockId, which a full-page target cannot carry;
      // land on the listing page, where each block links to its editor.
      path: "customer-accounts-ad-blocks",
    },
    synonyms: ["ad blocks edit", "customer accounts ad blocks edit"],
  },
] as const satisfies readonly SettingGroupDefinition<CustomerAccountsAdBlocksEditFlatTeamSettingGroupId>[];
